import React, { useContext, useEffect, useState } from "react";
import * as d3 from "d3";
import { Layout } from "flexlayout-react";
import "flexlayout-react/style/light.css";
import {
  combineVectorSetVector,
  onlyUnique,
} from "../../../utils/dataFunctions";
import { StoreContext } from "../../../store/Store";
import { LocalStoreContext } from "../store/LocalStore";
import { LayoutContext } from "../store/LayoutContext";
import { GlobalRefContext } from "../../../store/GlobalRefs";
import { RefContext } from "../store/RefContext";
import { actionTypes } from "../../../store/storeTypes";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { tickerData } from "../../../api/s3";
import {
  onAction,
  factory,
  layoutModelChange,
  onRenderTab,
  onRenderTabSet,
} from "./layoutFunctions";
import "../../../layout/layoutstyle.css";

const filterKeys = ["VectorSet", "VecLevel", "VecEvents", "VecDates"];
const parseDate = d3.timeParse("%m/%d/%Y");

export const VectorSet2Layout = () => {
  const [store, dispatch] = useContext(StoreContext);
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const [layoutState, setLayoutState] = useContext(LayoutContext);
  const refs = useContext(RefContext);
  const grefs = useContext(GlobalRefContext);
  const { auth, controlPopupMenu, debug, defaultTicker } = store;

  if (debug) {
    console.log("VectorSet2Layout");
  }

  const [selectedTicker, setSelectedTicker] = useState();

  if (lstore) {
    //do nothing
  }

  useEffect(() => {
    if (controlPopupMenu.selected["ticker"]) {
      setSelectedTicker(controlPopupMenu.selected["ticker"]);
    }
  }, [controlPopupMenu.selected, defaultTicker]);

  useEffect(() => {
    let isCancelled = false;
    if (auth) {
      if (selectedTicker) {
        if (refs.vectorset2CurrentTicker.current !== selectedTicker) {
          const asyncfunction = async () => {
            refs.vectorset2CurrentTicker.current = selectedTicker;
            const newState = {
              rawdata: [],
              rawdatacombined: [],
            };
            ldispatch({ type: actionTypes.SET_LOADING, payload: true });
            const data = await tickerData(
              auth,
              selectedTicker,
              grefs.tickerStorage.current
            );
            if (!isCancelled) {
              ldispatch({ type: actionTypes.SET_LOADING, payload: false });
              newState.rawdata = data;

              newState.rawdatacombined = combineVectorSetVector(
                newState.rawdata
              );
              const modelDateItem = newState.rawdatacombined["Close"]["_Px"]
                .map((item) => {
                  return { date: parseDate(item.Date), value: item.Px };
                })
                .sort((a, b) =>
                  a.date < b.date ? 1 : a.date > b.date ? -1 : 0
                )[0];

              ldispatch({
                type: lactionTypes.SET_MODEL_DATE_ITEM,
                payload: modelDateItem,
              });

              const sortAlphaNum = (a, b) =>
                a.localeCompare(b, "en", { numeric: true });
              const sortVeclevel = (a, b) => (a < b ? -1 : a === b ? 0 : 1);

              const defaults = filterKeys.reduce((a, b) => {
                return {
                  ...a,
                  [b]: newState.rawdata
                    .map((item) => (item[b] === null ? "" : item[b].toString()))
                    .filter(onlyUnique)
                    .sort(b === "VecLevel" ? sortVeclevel : sortAlphaNum),
                };
              }, {});

              filterKeys.forEach((key) => {
                defaults[key].unshift("All");
              });

              ldispatch({
                type: lactionTypes.SET_FILTER_DEFAULTS,
                payload: JSON.parse(JSON.stringify(defaults)),
              });
              ldispatch({
                type: lactionTypes.SET_FILTER,
                payload: {
                  ...JSON.parse(JSON.stringify(defaults)),
                  VectorSet: ["Close", "TopBottom"],
                },
              });

              ldispatch({
                type: lactionTypes.SET_VECTORSET2,
                payload: newState,
              });
            }
          };
          ///get data from s3
          asyncfunction();
          refs.layoutRefs.current["brush"]["History"] = {
            x: [],
            y: [],
          };
          refs.layoutRefs.current["brush"]["VectorSetStudy"] = {
            x: [],
            y: [],
          };
        }
      }
    }
    return () => {
      isCancelled = true;
    };
  }, [
    auth,
    selectedTicker,
    ldispatch,
    dispatch,
    grefs.tickerStorage,
    refs.layoutRefs,
    refs.vectorset2CurrentTicker,
  ]);

  if (layoutState.model) {
    return (
      <Layout
        ref={layoutState.layout}
        model={layoutState.model}
        factory={factory}
        onRenderTabSet={(tabSetNode) => onRenderTabSet(tabSetNode, refs)}
        onModelChange={(model) =>
          layoutModelChange(model, layoutState, setLayoutState, grefs)
        }
        onRenderTab={(node, renderState) =>
          onRenderTab(node, renderState, refs.componentSize)
        }
        onAction={(action) => onAction(action, layoutState)}
      />
    );
  } else return null;
};
